import React from 'react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { Star } from 'lucide-react';
const URL_COMBO = 'https://www.compradigitalya.com/checkouts/cn/hWNBfCDdHQUTNK8tIikCUts2/es-ar?_r=AQAB1bvEcqlGPcyGyamgvjBgxYvtyuUNQZ9h35zPIFBVk78&cart_link_id=nZEWN4Xd&preview_theme_id=141062045767';
const URL_NEGOCIO = 'https://www.compradigitalya.com/checkouts/cn/hWNBdUFFymDYbXpYXXycWa3O/es-ar?_r=AQAB9ZpcoTmOvmIKllCe542nTswrOhwYIuaMfsTG0ScpiM8&cart_link_id=S2jicxQP&preview_theme_id=141062045767';
export function OfferSection() {
  return <section className="py-20 px-4 max-w-5xl mx-auto border-t border-primary/20" data-id="element-180">
      <div className="text-center mb-12" data-id="element-181">
        <div className="inline-block bg-primary/10 border border-primary/40 text-primary px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-wider mb-6" data-id="element-182">
          ⚡ Oferta por tiempo limitado
        </div>
        <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-6" data-id="element-183">
          Sumate a los +500 profes que ya recuperaron sus domingos
        </h2>
        <h3 className="text-base md:text-xl font-bold text-zinc-400 mb-6 flex items-center justify-center gap-2" data-id="element-184">
          <span data-id="element-185">⏰</span> EL PRECIO DE LANZAMIENTO CIERRA EN:
        </h3>

        <div className="mb-8" data-id="element-186">
          <Countdown data-id="element-187" />
        </div>

        <div className="inline-block bg-red-500/10 border border-red-500/30 text-red-400 px-6 py-3 rounded-xl font-bold mb-8 text-sm md:text-base" data-id="element-188">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold mb-12" data-id="element-189">
          ELEGÍ TU COMBO
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-190">
        {/* Card 1 */}
        <div className="bg-surface border border-zinc-800 hover:border-primary/40 transition-colors rounded-3xl p-8 flex flex-col relative" data-id="element-191">
          <div className="mb-6" data-id="element-192">
            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-193">
              <span data-id="element-194">📘</span> COMBO COMPLETO
            </h3>
            <p className="text-zinc-400 text-sm" data-id="element-195">6 Tomos + 6 Bonos</p>
          </div>

          <div className="bg-surface2 p-4 rounded-xl mb-6 text-sm text-zinc-300" data-id="element-196">
            <span className="font-bold text-white" data-id="element-197">Ideal para:</span> Profes que
            quieren resolver todo el año de clases con un sistema progresivo
            completo
          </div>

          <div className="mb-8 flex-grow" data-id="element-198">
            <div className="text-zinc-500 line-through text-xl font-bold mb-1" data-id="element-199">
              $51.000
            </div>
            <div className="text-5xl font-extrabold text-white mb-2" data-id="element-200">
              $19.990 <span className="text-2xl text-zinc-400" data-id="element-201">ARS</span>
            </div>
          </div>

          <Button href={URL_COMBO} fullWidth className="py-4 text-lg" data-id="element-202">
            → QUIERO MI COMBO COMPLETO
          </Button>
        </div>

        {/* Card 2 - Featured */}
        <div className="bg-surface border-2 border-primary rounded-3xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(74,222,128,0.2)] transform md:-translate-y-4" data-id="element-203">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-black font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1" data-id="element-204">
            <Star className="w-4 h-4 fill-black" data-id="element-205" /> MÁS ELEGIDO
          </div>

          <div className="mb-6" data-id="element-206">
            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-207">
              <span data-id="element-208">🏆</span> COMBO + NEGOCIO
            </h3>
            <p className="text-zinc-400 text-sm" data-id="element-209">
              6 Tomos + 6 Bonos + Método Profe Empresario
            </p>
          </div>

          <div className="bg-primary/10 border border-primary/30 p-4 rounded-xl mb-6 text-sm text-zinc-300" data-id="element-210">
            <span className="font-bold text-white" data-id="element-211">Ideal para:</span> Profes que
            además quieren construir un negocio rentable, cobrar lo que valen y
            llenar sus grupos
          </div>

          <div className="mb-8 flex-grow" data-id="element-212">
            <div className="text-zinc-500 line-through text-xl font-bold mb-1" data-id="element-213">
              $76.000
            </div>
            <div className="text-5xl font-extrabold text-white mb-2" data-id="element-214">
              $27.990 <span className="text-2xl text-zinc-400" data-id="element-215">ARS</span>
            </div>
          </div>

          <Button href={URL_NEGOCIO} fullWidth className="py-4 text-lg shadow-[0_0_20px_rgba(74,222,128,0.3)]" data-id="element-216">
            → QUIERO EL COMBO + NEGOCIO
          </Button>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-6 text-xs md:text-sm text-zinc-400 font-medium mt-12" data-id="element-217">
        <span className="flex items-center gap-2" data-id="element-218">🔒 Pago 100% seguro</span>
        <span className="flex items-center gap-2" data-id="element-219">⚡ Acceso en 5 minutos</span>
        <span className="flex items-center gap-2" data-id="element-220">🛡️ Garantía 7 días</span>
        <span className="flex items-center gap-2" data-id="element-221">💳 Mercado Pago</span>
      </div>
    </section>;
}